'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Assistance = function Assistance(_ref) {
  var lightOn = _ref.lightOn,
      lampSize = _ref.lampSize,
      lampColor = _ref.lampColor;
  return _react2.default.createElement(
    'svg',
    { width: lampSize, height: lampSize, viewBox: '0 0 36 36', className: 'jsx-1096852007'
    },
    _react2.default.createElement(
      'g',
      {
        className: 'jsx-1096852007'
      },
      _react2.default.createElement('path', {
        fill: lampColor,
        d: 'M23 23c0-3.7 3.6-4.4 3.6-9.4C26.6 8.7 23 5 18 5s-8.6 3.7-8.6 8.6c0 4.9 3.6 5.6 3.6 9.4v4.8c0 .6.5 1.1 1.1 1.1h.5l.1.4.3.7c.2.6.8 1 1.4 1h3.1c.6 0 1.2-.4 1.4-1l.3-.7.1-.4h.5c.6 0 1.1-.5 1.1-1.1V23zm-12.6-9.3c0-4.5 3.1-7.6 7.6-7.6s7.6 3.1 7.6 7.6c0 2.3-.9 3.5-1.8 4.8-.7 1-1.4 2-1.7 3.4h-8.2c-.3-1.4-1-2.5-1.7-3.4-.9-1.3-1.8-2.5-1.8-4.8zm3.6 9.2h8v2h-8V23v-.1zm6 6.7c-.1.2-.3.3-.5.3h-3.1c-.2 0-.4-.1-.5-.3l-.3-.7H20.3l-.3.7zm2-1.8c0 .1-.1.1-.1.1H14.1c-.1 0-.1-.1-.1-.1v-1.9h8v1.9z',
        className: 'jsx-1096852007'
      }),
      lightOn ? _react2.default.createElement('path', {
        fill: lampColor,
        d: 'M18 9.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5c-3.3 0-5.6 2.3-5.6 5.6 0 .3.2.5.5.5s.5-.2.5-.5c0-2.8 1.8-4.6 4.6-4.6zm0-6c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2c0 .3.2.5.5.5zM6.9 13.2h-2c-.3 0-.5.2-.5.5s.2.5.5.5h2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm24.2 0h-2c-.3 0-.5.2-.5.5s.2.5.5.5h2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-21.3-7c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7L9.1 4.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l1.4 1.4zm0 15l-1.4 1.4c-.2.2-.2.5 0 .7.1.1.2.1.4.1s.3 0 .4-.1l1.4-1.4c.2-.2.2-.5 0-.7s-.6-.2-.8 0zm16.4 0c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l1.4 1.4c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-1.5-1.4zm.7-17.1l-1.4 1.4c-.2.2-.2.5 0 .7.1.1.2.1.4.1s.3 0 .4-.1l1.4-1.4c.2-.2.2-.5 0-.7-.3-.2-.6-.2-.8 0z',
        className: 'jsx-1096852007'
      }) : _react2.default.createElement('path', {
        fill: lampColor,
        d: 'M18 9.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5c-3.4 0-5.6 2.3-5.6 5.6 0 .3.2.5.5.5s.5-.2.5-.5c0-2.8 1.8-4.6 4.6-4.6z',
        className: 'jsx-1096852007'
      })
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '1096852007'
      },
      ['span.jsx-1096852007{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;height:100%;}']
    )
  );
};

Assistance.propTypes = {
  lightOn: _propTypes2.default.bool,
  lampSize: _propTypes2.default.number,
  lampColor: _propTypes2.default.string
};

Assistance.defaultProps = {
  lampSize: 36,
  lampColor: '#fff'
};

exports.default = Assistance;